<template>
  <div class="service-list">
    <slot />
    <service
      v-for="item in services"
      :key="item.key"
      :icon-url="item.imageUrl"
    >
      {{ item.name }}
    </service>
  </div>
</template>

<script>

import Service from './Service';

export default {
  name: 'ServiceList',
  components: {
    Service,
  },
  props: {
    services: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
  .service-list {
    > div {
      margin-bottom: 13px;
      @media screen and (min-width: $tablet-width) {
        margin-bottom: 7px;
        margin-right: 20px;
      }
    }
  }
</style>
